"use client";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import dynamic from "next/dynamic";
const RateContextMenu = dynamic(
  () => import("@/app/components/review-product/product-details-rate/RateContextMenu"),
  { ssr: false },
);
const ProductBoxTail = dynamic(() => import("./product-box-helpers/ProductBoxTail"), {
  ssr: false,
});
import {
  Config_Customize,
  IProduct_Category_Config_Customize,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import {
  ITheme,
} from "@/api/AppApi/services/company/interfaces/ICompany";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import SvgPlus from "./product-box-helpers/btn-expanding-add-to-card/btn-esxpanding-types/btn-expanding-icons/SvgPlus";
import { useIdleReveal } from "@/hooks/useIdleReveal";
import useSellingMode from "@/hooks/useSellingMode";
import { memo } from "react";
const Attributes = dynamic(
  () =>
    import(
      "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/Attributes"
    ),
  { ssr: false },
);
import { useProductBox } from "./context/ProductBoxContext";

interface Props extends IProduct {
  scrollableTabs: boolean;
  size: Size;
  theme: ITheme;
  priority: boolean;
  Customize?: Config_Customize;
  isGrid: boolean;
  showCustomEventData?: boolean;
  hideAddToCart?: boolean;
  showAllAttributes?: boolean;
  bundleItemQuantity?: number;
}
const ProductBoxTailAndRate: React.FC<Props> = (props) => {
  const {
    setSelectedChildIndex,
    product,
    quick_variant_selection,
    setSelectedAttributes,
    allow_user_request_stock_availability_reminder,
    showRate
  } = useProductBox();
  const { enableAddToCart } = useSellingMode();
  const isRevealed = useIdleReveal(props.priority);
  const { id,  rate, ratings, can_review, Customize } = props;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {!isRevealed ? (
        <div className="product-tail ">
          <div className={`skeleton-text col-6 p-0`} />
          <div className={`btn-expanded-v-add-to-card skeleton-text`}>
            <div style={{ marginTop: -2 }}>
              <SvgPlus disabled />
            </div>
          </div>
        </div>
      ) : (
        <>
          {showRate && (
            <div className="prodcut-box-rate" style={{ height: 24 }}>
              <RateContextMenu
                rate={rate}
                ratings={ratings}
                productId={id}
                canReview={can_review}
              />
            </div>
          )}
          {quick_variant_selection && (
            <div>
              {product?.attributes_builder?.length > 0 &&
                product?.children?.filter(
                  (child) => child?.attribute_ids?.length > 0,
                ).length > 0 && (
                  <div id="attributes-selector">
                    <Attributes
                      product={product}
                      setSelectedChildIndex={setSelectedChildIndex}
                      setSelectedAttributesValues={setSelectedAttributes}
                      autoSelectFirstChild={false}
                      isProductBox
                      showAllAttributes={props.showAllAttributes}
                      allow_user_request_stock_availability_reminder={
                        allow_user_request_stock_availability_reminder
                      }
                    />
                  </div>
                )}
            </div>
          )}
          {enableAddToCart && (
            <ProductBoxTail
              {...props}
              Customize={Customize as IProduct_Category_Config_Customize}
            />
          )}
        </>
      )}
    </div>
  );
};

export default memo(ProductBoxTailAndRate);
